'use client'

import React from "react";
import { StyledCheckbox, StyledFormControlLabel, StyledFormGroup } from "./styles";

interface CheckboxProps {
  label: string;
  checked: boolean;
  name: string;
  error?: boolean;
  onChange: (event: React.SyntheticEvent, checked: boolean) => void;
  disabled?: boolean;
}

export const Checkbox = ({ label, checked, name, onChange, error, disabled }: CheckboxProps) => {
  return (
    <StyledFormGroup>
      <StyledFormControlLabel
        $error={error}
        control={<StyledCheckbox $error={error} />}
        label={label}
        checked={checked}
        onChange={onChange}
        name={name}
        disabled={disabled}
      />
    </StyledFormGroup>
  );
};

